import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import * as S from './SiderMenu.styles';
import { sidebarNavigation } from '../sidebarNavigation';
import { buildNavAccess, filterNavigation, toPath } from '../navigationAccess';
import { useUserRoles } from '@app/hooks/useUserRoles';
import { readUser } from '@app/services/localStorage.service';

interface SiderContentProps {
  setCollapsed: (isCollapsed: boolean) => void;
}

const SiderMenu: React.FC<SiderContentProps> = ({ setCollapsed: _setCollapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();
  // useUserRoles làm mới /api/me rồi re-render → quyền mới nhất được áp vào menu.
  useUserRoles();

  const filteredNav = filterNavigation(sidebarNavigation, buildNavAccess(readUser()));
  const isCurrent = (url?: string) => Boolean(url) && toPath(url as string) === location.pathname;

  const currentMenuItem = filteredNav.flatMap((nav) => nav.children ?? [nav]).find(({ url }) => isCurrent(url));
  const defaultSelectedKeys = currentMenuItem ? [currentMenuItem.key] : [];

  const openedSubmenu = filteredNav.find(({ children }) => children?.some(({ url }) => isCurrent(url)));
  const defaultOpenKeys = openedSubmenu ? [openedSubmenu.key] : [];

  return (
    <S.Menu
      mode="inline"
      defaultSelectedKeys={defaultSelectedKeys}
      defaultOpenKeys={defaultOpenKeys}
      items={filteredNav.map((nav) => {
        const isSubMenu = nav.children?.length;

        return {
          key: nav.key,
          title: t(nav.title),
          label: isSubMenu ? t(nav.title) : <Link to={nav.url || ''}>{t(nav.title)}</Link>,
          icon: nav.icon,
          children:
            isSubMenu &&
            nav.children &&
            nav.children.map((childNav) => ({
              key: childNav.key,
              label: <Link to={childNav.url || ''}>{t(childNav.title)}</Link>,
              title: t(childNav.title),
              icon: childNav.icon,
            })),
        };
      })}
    />
  );
};

export default SiderMenu;
